import { Avatar } from '@material-ui/core';
import { FunctionComponent } from 'react';

export const AssemblyAvatar: FunctionComponent = () => (
  <Avatar
    alt="Assembly"
    src="/images/branding/assembly-logo-icon-white-on-black.svg"
    className="m-auto w-[60px] h-[60px]"
    variant="square"
  />
);
